import React from 'react';
import { AppRoute } from '../routes.types';
import { DataRequestDashboardPage } from '../../containers/DataRequest/DataRequestDashboardPage/DataRequestDashboardPage';
import { ProjectEditorHost } from '../../containers/Admin/DataRequest/ProjectEditorHost/ProjectEditorHost';

export const BUILT_IN_ROUTES: AppRoute[] = [
    { path: '/data-request-dashboard-built-in', element: <DataRequestDashboardPage isBuiltInMode={true} /> },
    { path: '/project-editor-built-in', element: <ProjectEditorHost /> },
];
